module.exports = __webpack_public_path__ + "static/media/Logo1.489a4840.png";